<template>
    <auction-dialog title="응찰기록보기" @open="init" @close="destroy">
        <template #activator="{attrs,on}">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <template #default>
            <auction-bids-data ref="bids-data" :bids="bids" />
        </template>
    </auction-dialog>
</template>

<script>
import AuctionDialog from "./auction-dialog.vue";
import AuctionBidsData from "./auction-bids-data.vue";

export default {
    props: {
        bids: { type: Array, default: () => [] },
    },
    components: {
        AuctionDialog,
        AuctionBidsData,
    },
    methods: {
        async init() {
            this.$emit("refresh");
        },
        async destroy() {
            this.$nextTick(() => this.$refs["bids-data"]?.$destroy?.());
        },
    },
};
</script>

<style></style>
